import { Controller } from '@hotwired/stimulus';

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/;
const GTM_SCRIPT_SELECTOR = 'script[src*="googletagmanager.com/gtm.js"]';

// Manages Google Tag Manager initialization and Turbo-compatible pageview
// tracking. Loads the GTM script asynchronously (non-blocking) and pushes
// a virtual pageview on every page visit.
//
// Relies on Turbo Drive replacing the <body> on each navigation, which
// causes Stimulus to reconnect this controller and trigger a new pageview.
//
// Usage:
//   <div data-controller="gtm" data-gtm-id-value="GTM-XXXXX" hidden>
export default class GtmController extends Controller {
  static values = { id: String };

  connect() {
    if (!this.idValue || !GTM_ID_PATTERN.test(this.idValue)) return;

    this._initializeGtm();
    this._trackPageview();
  }

  disconnect() {
    this._teardownScript();
  }

  _initializeGtm() {
    if (document.querySelector(GTM_SCRIPT_SELECTOR)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.idValue}`;
    document.head.appendChild(script);
  }

  _trackPageview() {
    window.dataLayer.push({
      event: 'turbo:pageview',
      virtualUrl: window.location.pathname + window.location.search,
    });
  }

  _teardownScript() {
    const script = document.querySelector(GTM_SCRIPT_SELECTOR);
    if (script) script.remove();
  }
}
